import AGREGAR_OBRA_SOLICITADA from '@/graphql/mutations/administracion/obrassolicitudes/agregarObraSolicitada.gql';
import ACTUALIZAR_OBRA_SOLICITADA from '@/graphql/mutations/administracion/obrassolicitudes/actualizarObraSolicitada.gql';
import REMOVER_OBRA_SOLICITADA from '@/graphql/mutations/administracion/obrassolicitudes/removerObraSolicitada.gql';
import OBRAS_SOLICITUDES from '@/graphql/querys/administracion/obrassolicitudes/obrasSolicitudes.gql';
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import FUENTES_FINANCIERAS from '@/graphql/querys/administracion/catalogos/fuentesfinancieras/fuentesFinancieras.gql';
import OBRAS_VALIDADAS_SIN_SOLICITUD from '@/graphql/querys/administracion/obrassolicitudes/obrasValidadasSinSolicitud.gql';

export default {
  apollo: {
    municipios: {
      query: MUNICIPIOS,
    },
    fuentesFinancieras: {
      query: FUENTES_FINANCIERAS,
    },
    obrasValidadasSinSolicitud: {
      query: OBRAS_VALIDADAS_SIN_SOLICITUD,
      variables() {
        return {
          ejercicio: this.ejercicioSeleccionado,
        };
      },
      skip() {
        return !this.ejercicioSeleccionado;
      },
    },
  },
  data() {
    return {
      ejercicioSeleccionado: null,
      itemsTipoProyecto: ['SOCIAL', 'APOYO', 'PRODUCTIVO'],
      itemsTiposLocalidad: ['COLONIA POPULAR', 'POBLACIÓN RURAL', 'ZONA INDIGENA'],
      itemsModalidadEjecucion: ['CONTRATO', 'ADMON. DIRECTA', 'MIXTA'],
      itemsTiposObra: ['NUEVA', 'AMPLIACIÓN', 'REHABILITACIÓN', 'PROCESO'],
    };
  },
  methods: {
    updateObrasSinSolicitud() {
      this.$apollo.queries.obrasValidadasSinSolicitud.refetch();
    },
    // Actualizar ejercicio cuando cambia la fecha de memorándum
    mixActualizarEjercicio(fecha) {
      if (!fecha) {
        this.ejercicioSeleccionado = null;
        return;
      }
      const year = new Date(fecha).getFullYear();
      this.ejercicioSeleccionado = year;
    },
    // Agregar Solicitud de Obra
    getTipoProyecto(tipo) {
      const itemstipodeproyecto = [
        { proyecto: 'SOCIAL', valor: 1 },
        { proyecto: 'PRODUCTIVO', valor: 2 },
        { proyecto: 'APOYO', valor: 3 },
      ];
      const tipoProyecto = itemstipodeproyecto.find((item) => item.valor === tipo);
      return tipoProyecto ? tipoProyecto.proyecto : null;
    },
    async mixAgregarSolicitudObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Subir imagenes de macro y micro localizacion
      if (this.rutaArchivoMicroLocalizacion) {
        const imagenMicrolocalizcion = {
          nombre: 'microlocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMicro').files[0],
        };
        await this.mixSubirImagen(imagenMicrolocalizcion, 'micro');
      }
      if (this.rutaArchivoMacroLocalizacion) {
        const imagenMacrolocalizcion = {
          nombre: 'macrolocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMacro').files[0],
        };
        await this.mixSubirImagen(imagenMacrolocalizcion, 'macro');
      }

      // Agregar los avances financieros al calendario
      this.solicitudObra.calendario = JSON.stringify(this.avanceFinanciero);

      // Enviar la informacion
      await this.$apollo
        .mutate({
          mutation: AGREGAR_OBRA_SOLICITADA,
          variables: {
            obra: this.solicitudObra,
          },
          update: (store, { data: { agregarObraSolicitada } }) => {
            const query = {
              query: OBRAS_SOLICITUDES,
            };

            const { obrasSolicitudes } = store.readQuery(query);
            obrasSolicitudes.push(agregarObraSolicitada);

            store.writeQuery({
              ...query,
              data: {
                obrasSolicitudes,
              },
            });

            // Actualizar el caché de obras validadas sin solicitud para quitar la obra agregada
            try {
              const obrasQuery = {
                query: OBRAS_VALIDADAS_SIN_SOLICITUD,
                variables: {
                  ejercicio: this.ejercicioSeleccionado,
                },
              };

              const dataObras = store.readQuery(obrasQuery);
              if (dataObras && dataObras.obrasValidadasSinSolicitud) {
                const obrasActualizadas = dataObras.obrasValidadasSinSolicitud
                  .filter((obra) => obra.id !== this.solicitudObra.idObra);

                store.writeQuery({
                  ...obrasQuery,
                  data: {
                    obrasValidadasSinSolicitud: obrasActualizadas,
                  },
                });
              }
            } catch (e) {
              // Si no existe el query en caché, no hacer nada
            }
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Actualizar Solicitud de Obra
    async mixActualizarSolicitudObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Subir imagenes de macro y micro localizacion
      if (this.rutaArchivoMicroLocalizacion && this.rutaArchivoMicroLocalizacion.includes('blob')) {
        const imagenMicrolocalizcion = {
          nombre: 'microlocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMicro').files[0],
        };
        await this.mixSubirImagen(imagenMicrolocalizcion, 'micro');
      }

      if (this.rutaArchivoMacroLocalizacion && this.rutaArchivoMacroLocalizacion.includes('blob')) {
        const imagenMacrolocalizcion = {
          nombre: 'macrolocalizacion',
          path: 'Solicitudes Obras/imagenes',
          imagen: document.getElementById('anexoMacro').files[0],
        };
        await this.mixSubirImagen(imagenMacrolocalizcion, 'macro');
      }

      // Agregar los avances financieros actualizados al calendario
      this.solicitudObra.calendario = JSON.stringify(this.avanceFinanciero);

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_OBRA_SOLICITADA,
          variables: {
            id: this.solicitudObraEditar.id,
            obra: this.solicitudObra,
          },
          update: (store, { data: { actualizarObraSolicitada } }) => {
            const query = {
              query: OBRAS_SOLICITUDES,
            };
            const data = store.readQuery(query);
            const { obrasSolicitudes } = data;
            const index = obrasSolicitudes
              .findIndex((obraSolicitud) => obraSolicitud.id
              === actualizarObraSolicitada.id);
            if (index !== -1) {
              obrasSolicitudes.splice(index, 1, actualizarObraSolicitada);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Eliminar Solicitud de Obra
    async mixEliminarSolicitudObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OBRA_SOLICITADA,
        variables: {
          id: this.solicitudObraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: OBRAS_SOLICITUDES,
          };
          const data = store.readQuery(query);
          const { obrasSolicitudes } = data;
          const index = obrasSolicitudes
            .findIndex((obraSolicitud) => obraSolicitud.id === this.solicitudObraEliminar.id);
          if (index !== -1) {
            obrasSolicitudes.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
        // Refrescar la lista de obras validadas sin solicitud
        this.ejercicioSeleccionado = this.solicitudObraEliminar.ejercicio;
        this.$apollo.queries.obrasValidadasSinSolicitud.refetch();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixSubirImagen(datosImagen, tipo) {
      const dataForm = new FormData();
      dataForm.append('custom_name', datosImagen.nombre);
      dataForm.append('custom_path', datosImagen.path);
      dataForm.append('anexo', datosImagen.imagen);

      await this.axios
        .post(this.$urlFileServer, dataForm, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ data }) => {
          const archivo = data;
          if (tipo === 'macro') {
            this.solicitudObra.imagenMacrolocalizacion = archivo.data.public_key;
            return;
          }
          this.solicitudObra.imagenMicrolocalizacion = archivo.data.public_key;
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
    },
    mixSetDatosFormulario() {
      const obraSeleccionada = this.getObrasValidadasSinSolicitud.find(
        (obra) => obra.id === this.solicitudObra.idObra,
      );
      if (obraSeleccionada) {
        // Datos generales
        this.solicitudObra.meta = obraSeleccionada.meta || '';
        this.solicitudObra.tipoProyecto = this.getTipoProyecto(obraSeleccionada.tipoProyecto) || '';
        this.solicitudObra.montoSolicitado = obraSeleccionada.total || 0;
        this.solicitudObra.montoSolicitadoMunicipal = obraSeleccionada.total || 0;

        // Datos de ubicación
        this.solicitudObra.idMunicipio = obraSeleccionada.ubicacion?.idMunicipio || '';
        this.solicitudObra.localidad = obraSeleccionada.ubicacion?.localidad || '';
        // this.solicitudObra.tipoLocalidad = obraSeleccionada.ubicacion?.tipoLocalidad || '';
        this.solicitudObra.esCabecera = obraSeleccionada.ubicacion?.cabeceraMunicipial || false;

        // Datos de impacto
        this.solicitudObra.beneficiariosCantidad = obraSeleccionada.impacto?.beneficiados || 0;
        this.solicitudObra.metaFisica = obraSeleccionada.impacto?.metaFisica || 0;
        this.solicitudObra.unidadMetaFisica = obraSeleccionada.impacto?.metaFisicaUnidad || '';
        this.solicitudObra.justificacionSocial = obraSeleccionada.impacto?.justificacionSocial || '';
        this.solicitudObra.justificacionTecnica = obraSeleccionada.impacto?.justificacionTecnica || '';
        this.solicitudObra.problematica = obraSeleccionada.impacto?.problematica || '';
        this.solicitudObra.conceptosAEjecutar = obraSeleccionada.impacto?.conceptosEjecutar || '';

        // Fechas
        this.solicitudObra.fechaInicioObra = obraSeleccionada.fechaProbableInicio || null;
        this.solicitudObra.fechaTerminoObra = obraSeleccionada.fechaProbableTermino || null;
      } else {
        this.solicitudObra.meta = '';
        this.solicitudObra.tipoProyecto = '';
        this.solicitudObra.idMunicipio = '';
        this.solicitudObra.localidad = '';
        this.solicitudObra.tipoLocalidad = '';
        this.solicitudObra.esCabecera = false;
        this.solicitudObra.beneficiariosCantidad = 0;
        this.solicitudObra.metaFisica = 0;
        this.solicitudObra.unidadMetaFisica = '';
        this.solicitudObra.justificacionSocial = '';
        this.solicitudObra.justificacionTecnica = '';
        this.solicitudObra.problematica = '';
        this.solicitudObra.conceptosAEjecutar = '';
        this.solicitudObra.fechaInicioObra = null;
        this.solicitudObra.fechaTerminoObra = null;
        this.solicitudObra.montoSolicitado = 0;
        this.solicitudObra.montoSolicitadoMunicipal = 0;
      }
    },
  },
  computed: {
    getTiposObras() {
      if (!this.tiposObras) return [];
      return this.tiposObras;
    },
    getMunicipios() {
      if (!this.municipios) return [];
      return this.municipios;
    },
    getFuentesFinancieras() {
      if (!this.fuentesFinancieras) return [];
      return this.fuentesFinancieras;
    },
    getObrasValidadasSinSolicitud() {
      if (!this.obrasValidadasSinSolicitud) return [];
      return this.obrasValidadasSinSolicitud;
    },
  },
};
